module.exports = __webpack_public_path__ + "static/img/summarize.3279f6c8.png";